module.exports = __webpack_public_path__ + "img/logo-woco-amvest-color.56781f6f.png";